import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { IconSvgComponent } from '../icon/svg-icon.component';
import { IconsConstants } from '../../common';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { ButtonCaller, ButtonSharedComponent } from '../shared-button-component/shared-button.component';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { BaseFilterComponent, FilterFormGroup } from '../base-filter-component/base-filter-component';
import { SvgIcon } from '../../interfaces';
import { CheckObjectValuesPipe } from '../../pipes/check-object-has-value.pipe';

@Component({
  selector: 'app-filters-container',
  standalone: true,
  imports: [
    //modules
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDividerModule,
    MatMenuModule,
    //components
    IconSvgComponent,
    ButtonSharedComponent,
    CheckObjectValuesPipe
  ],
  templateUrl: './filters-container.component.html',
  styleUrls: ['./filters-container.component.scss'],
})
export class FiltersContainerComponent extends BaseFilterComponent<any> implements OnInit {
  //inputs
  @Input() icon: SvgIcon = IconsConstants.SORT_ICON;
  @Input() label: string = this.translationsList['BUTTONS']['FILTERS'];
  @Input() disableResetButton: boolean;
  @Input() showSearchButton: boolean = true;
  //outputs
  @Output() searchEventEmitter: EventEmitter<boolean> = new EventEmitter();
  @Output() resetEventEmitter: EventEmitter<boolean> = new EventEmitter();
  //viewchildren
  @ViewChild(MatMenuTrigger) menuTrigger: MatMenuTrigger;

  constructor(injector: Injector) {
    super(['BUTTONS'], injector);
  }

  protected override initializeForm(): void {
    this.form = this.injector.get(FormGroupDirective).form;
  }

  clickMenu(event: Event): void {
    event.stopPropagation();
  }

  onClickSearchButton(): ButtonCaller {
    return () => {
      this.onSearch();
      if (this.menuTrigger) {
        this.menuTrigger.closeMenu();
      }
    }
  }

  override onSearch(): void {
    this.isSearch = super.checkAndCountNonNullFilters();
    if (this.form instanceof FilterFormGroup) {
      super.onSearch();
      this.form.formSubmitted.emit('search');
    }
    this.searchEventEmitter.emit(true);
  }

  override onReset(): void {
    super.onReset();
    if (this.form instanceof FilterFormGroup) {
      this.form.formSubmitted.emit('reset');
    }
    this.resetEventEmitter.emit(true);
  }

  protected override getQueryParamsFromUrl(): void {
    super.getQueryParamsFromUrl();
    if (this.form instanceof FilterFormGroup) {
      this.form.formSubmitted.emit('load');
    }
  }
}
